
import { map } from "rxjs";

export const mapKey = <T extends Object, K extends keyof T>(key: K) => map((object: T) => object[key] as T[K]);
